import WideoAsset from "./WideoAsset";

export default class WideoAssetImage extends WideoAsset {
    public getAssetType = () => {
        return "wideoImages";
    }    
}